import React from 'react'
import './intro.css';
import bg from '../../assets/image.png';

import btnImg from '../../assets/hireme.png';

const Intro = () => {
  return (
    <section id='intro'>
        <div className='introContent'>
        <span className='hello'>Hello and Welcome,</span>
        <span className='introText'>I'm <span className='introName'>Ratan</span><br/>An Engineer by Education
        <p className='introPara'>Software Engineer by Profession, Public Speaker by Interest, Video Content Creator by Hobby...</p>
       <a href='https://drive.google.com/file/d/1mGlj9Tbe1FhC7MgKbaKt8-t03p8Bfkwl/view?usp=sharing' target='_blank' rel="noreferrer"> <button className='btn'><img src={btnImg} alt='' className='btnImg'/>My Resume</button></a>
        </span>
        </div>
        <img src={bg} alt='Profile' className='bg'></img>
    </section>
  )
}

export default Intro;